import type { Dispatch } from "react";
import { ApplicantCollection } from "../../../components/Applicant/ApplicantCollection";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessage";
import { ListInfo } from "../../../components/Info/ListInfo";
import { FormTextArea } from "../../../components/Input/FormTextArea";
import type { ComponentConfig } from "../types";
import type { ApplicantInfo, LoanDetails } from "./types";

interface LoanDetailsProps {
  applicantInfo: ApplicantInfo
  loanDetails: LoanDetails
  setComment: Dispatch<React.SetStateAction<string>>
  comment: string
  errorMessages: string
  noErrorMessage: string
}

export const LoanDetailsInfo = ({ applicantInfo, loanDetails, setComment, errorMessages, comment, noErrorMessage }: LoanDetailsProps) => {
  const formConfig: ComponentConfig[] = [
    {
      component: (
        <ApplicantCollection
          nationalId={applicantInfo?.nationalId}
          firstName={applicantInfo?.firstName}
          lastName={applicantInfo?.lastName}
          mobileNumber={applicantInfo?.mobileNumber}
          emailAddress={applicantInfo?.emailAddress}
        />
      ),
      order: 1,
    },
    {
      component: <ListInfo title="Loan details" context={loanDetails} />,
      order: 2,
    },
    {
      component: (
        <FormTextArea
          name="Comment"
          onChange={(e: string) => setComment(e)}
          label="Comment"
          defaultValue={comment}
        />
      ),
      order: 3,
    },
    {
      component: <ErrorMessages errors={[errorMessages]} />,
      order: 4,
      hide: errorMessages === noErrorMessage,
    },
  ];
  return formConfig
}